import { isNil } from "ramda";

export default function hasDiscountParam() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const withDiscount = urlParams?.get("withDiscount");

  return !isNil(withDiscount);
}
